import { render, staticRenderFns } from "./FileFlowDetail.vue?vue&type=template&id=030b9304&scoped=true"
import script from "./FileFlowDetail.vue?vue&type=script&lang=js"
export * from "./FileFlowDetail.vue?vue&type=script&lang=js"
import style0 from "./FileFlowDetail.vue?vue&type=style&index=0&id=030b9304&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030b9304",
  null
  
)

export default component.exports